import { type FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, useModal } from "../common/modal/Modal";
import { Button } from "../components/Button";
import { LinkGen } from "../LinkGen";

export const ModalPaywall: FC = () => {
	const { close } = useModal();
	const navigate = useNavigate();

	const handleNavigate = useCallback(() => {
		close();
		navigate(LinkGen.Settings.Billing());
	}, [close, navigate]);

	return (
		<Modal size="lg" className="text-center">
			<p className="text-black ">
				In order to execute, you need to upgrade to the paid version.
			</p>

			<Button onClick={handleNavigate}>Upgrade</Button>
		</Modal>
	);
};
